import { render, staticRenderFns } from "./DefaultNotificationModal.vue?vue&type=template&id=c5264bf2&scoped=true&"
import script from "./DefaultNotificationModal.vue?vue&type=script&lang=js&"
export * from "./DefaultNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNotificationModal.vue?vue&type=style&index=0&id=c5264bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5264bf2",
  null
  
)

export default component.exports